import React from 'react';
import Accordion from 'react-bootstrap/Accordion';

function FaqOne() {
    return (
        <div>
            {/* rts faq section area */}
            <div className="rts-faq-section rts-section-gap rts-faq-bg bg_image">
                <div className="container">
                    <div className="row align-items-center">
                        
                        {/* COLUNA ESQUERDA – TEXTO + FAQ */}
                        <div className="col-lg-6">
                            <div className="faq-two-inner">
                                <div className="title-area-faq">
                                    <span className="sub">DÚVIDAS FREQUENTES</span>
                                    <h2 className="title">
                                        Perguntas &amp; Respostas <br />
                                        <span className="sm-title">
                                            Sobre o <span>GB Partner</span>
                                        </span>
                                    </h2>
                                </div>

                                {/* faq accordion area */}
                                <div className="faq-accordion-area">
                                    <Accordion defaultActiveKey="0">

                                        {/* Pergunta 1 */}
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                <span>01. </span> O que é o GB Partner e como ele atua?
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                O GB Partner é uma plataforma integrada de soluções em crédito, 
                                                consultoria, inteligência de mercado e seguros. Atendemos empresas, 
                                                produtores rurais e pessoas físicas, reunindo cinco unidades: 
                                                GB Crédito, GB Agro, GB Empresas & Negócios, GB Inteligência de Mercado 
                                                e GB Corretora de Seguros. Atuamos de forma consultiva, analisando cada 
                                                caso e conectando o cliente às melhores soluções do mercado.
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* Pergunta 2 */}
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>
                                                <span>02. </span> Como funciona a intermediação de crédito?
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                Realizamos uma análise detalhada da necessidade do cliente, avaliando 
                                                documentação, indicadores financeiros e capacidade de pagamento. 
                                                Identificamos as melhores opções em bancos, cooperativas, fintechs e 
                                                instituições privadas. Acompanhamos o processo completo até a aprovação, 
                                                garantindo segurança, clareza e condições mais vantajosas.
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* Pergunta 3 */}
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>
                                                <span>03. </span> Quais segmentos o GB atende?
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                Atendemos empresas de variados portes, produtores rurais, pessoas físicas 
                                                e operações corporativas de maior complexidade. As unidades Agro e 
                                                Empresas atuam com análises técnicas e estratégicas, enquanto a GB Crédito 
                                                e a GB Corretora também atendem consumidores com crédito imobiliário, 
                                                auto financiamento e seguros.
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* Pergunta 4 */}
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>
                                                <span>04. </span> O GB trabalha apenas com bancos?
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                Não. Atuamos com bancos tradicionais, cooperativas, fintechs, fundos 
                                                privados, instituições do agronegócio e seguradoras renomadas. Essa ampla 
                                                rede aumenta as possibilidades de aprovação e garante soluções mais 
                                                específicas e vantajosas para cada perfil.
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* Pergunta 5 */}
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header>
                                                <span>05. </span> A GB atende pessoas físicas?
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                Sim. Atendemos pessoas físicas em serviços como crédito imobiliário, 
                                                auto financiamento, home equity, seguros patrimoniais, seguros de vida e consultorias 
                                                específicas. Nosso foco principal é empresarial e agro, mas pessoas 
                                                físicas também podem contar com nossas soluções em diversas áreas.
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* Pergunta 6 */}
                                        <Accordion.Item eventKey="5">
                                            <Accordion.Header>
                                                <span>06. </span> Como solicito uma análise ou proposta?
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                O processo é simples e rápido:<br /><br />
                                                1. O cliente entra em contato pelo WhatsApp ou formulário do site.<br />
                                                2. Coletamos informações básicas sobre a necessidade.<br />
                                                3. Realizamos uma análise inicial e apresentamos as alternativas.<br />
                                                4. Exibimos opções com taxas, prazos e exigências.<br />
                                                5. Após a escolha, damos andamento ao processo completo.<br /><br />
                                                Garantimos acompanhamento, transparência e agilidade em todas as etapas.
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* Pergunta 7 */}
                                        <Accordion.Item eventKey="6">
                                            <Accordion.Header>
                                                <span>07. </span> Por que escolher o GB ao invés de contratar direto?
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                Porque entregamos uma análise estratégica completa. Trabalhamos com 
                                                diversas instituições, ampliando as chances de aprovação e encontrando 
                                                condições melhores do que as obtidas diretamente. Nós montamos toda a 
                                                documentação, negociamos taxas e acompanhamos o processo para garantir 
                                                segurança, economia e resultados superiores.
                                            </Accordion.Body>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                                {/* faq accordion area end */}
                            </div>
                        </div>

                        {/* COLUNA DIREITA – IMAGEM */}
                        <div className="col-lg-6">
                            <div className="thumbnail-faq-four">
                                <img src="assets/images/faqs/2.png" alt="FAQ GB Partner" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* rts faq section area End */}
        </div>
    );
}

export default FaqOne;
